import { MajorProgram, MajorProgramsQuery } from 'capability-ng-major-explorer';
import { ResourceListServant } from 'capability-ng-resources';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { FavoriteCapabilityConfiguration } from '../../configuration';

interface IFavoriteModel {
  resources: any[];
  majors: any[];
}

interface IFavoriteFlags {
  showFavoritedMajors: boolean;
  showFavoritedResources: boolean;
  isLoading: boolean;
}

export class MyFavoritesCategoryController {
  private models: IFavoriteModel;
  private flags: IFavoriteFlags;

  constructor(
    private ngFavoriteCapabilityConfiguration: FavoriteCapabilityConfiguration,
    private phxAxTitleAnnouncerDelegate: any,
    private ngResourceListServant: ResourceListServant,
    private ngMajorProgramsQuery: MajorProgramsQuery,
    private loadFavoritesCommand: ICommand,
    private log: any
  ) {
    this.flags = {
      showFavoritedMajors: this.ngFavoriteCapabilityConfiguration.config.isMajorExplorerEnabled,
      showFavoritedResources: this.ngFavoriteCapabilityConfiguration.config.isResourcesEnabled,
      isLoading: true
    };

    this.loadFavoritesCommand()
      .then(() => {
        this.initializeModel();
        this.flags.isLoading = false;
      })
      .catch((error) => {
        this.flags.isLoading = false;
        this.log.user.error(error);
      });
  }

  initializeModel() {
    this.models = {
      resources: this.ngResourceListServant.getFavoriteResources(),
      majors: this.ngMajorProgramsQuery.result
    };
  }

  hasMajorFavorites(): boolean {
    return !_4.isEmpty(this.models.majors);
  }

  hasResourcesFavorites(): boolean {
    return !_4.isEmpty(this.models.resources);
  }

  onClickUnfavorite(title: string, type: string): void {
    this.phxAxTitleAnnouncerDelegate.announceChange(`${title} ${type} was removed from favorites.`);
    this.models.resources = this.ngResourceListServant.getFavoriteResources();
    this.models.majors = _4.filter(this.ngMajorProgramsQuery.result, (major: MajorProgram) => major.is_favorite);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-favorites/src/views/my_favorites_category/my_favorites_category_controller.ts